import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {vec3} from 'gl-matrix';

const tempVec = vec3.create();
const tempVec0 = vec3.create();

/**
 * copy-rotation
 */
export class CopyRotation extends Component {
    static TypeName = 'copy-rotation';

    /* Properties that are configurable in the editor */

    @property.enum(['x', 'y', 'z'])
    axis!: number;

    @property.object({required: true})
    other!: Object3D;

    update() {
        this.other.getForwardWorld(tempVec);
        tempVec[this.axis] = 0;
        vec3.normalize(tempVec, tempVec);
        this.object.getPositionWorld(tempVec0);
        vec3.add(tempVec, tempVec, tempVec0);
        this.object.lookAt(tempVec);
    }
}
